/* eslint-disable */
<template>
  <div>
    <div class="container-fluid w-100 no-padding">
      <div class="row bg-primary-dark">
        <div class="col-md-4 mb-2 mt-2 align-middle d-flex flex-row">
          <h4 class="mr-4">Fatura Yüklemeleri</h4>
        </div>
        <div class="col-md-4 mb-2 mt-2">
          <div class="form-row">
            <div class="col-md-12">
              <label for="yearSelection">Yıl Seçimi</label>
              <select v-model="selectedYear" class="form-control" id="yearSelection" @change="onYearChange()">
                <option value="2026">2026</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
              </select>
            </div>
          </div>
          <!--
          <div class="row">
            <div class="col-md-3">
              <label for="out-retailer">Bayii Adı</label>
              <select class="custom-select mr-2" id="out-retailer" v-model="selectedRetailer">
                <option value="0" selected>Bayii seçiniz...</option>
                <option v-for="(retailer, retailerIndex) in retailers"
                  v-bind:key="'retailer-'+ retailerIndex"
                  :value="retailer.RETAILER_ID.toString()">
                  {{retailer.RETAILER_NAME}}</option>
                <option value="100" selected>Stok Dışı Cihazlar</option>
                <option value="101" selected>ARIZA</option>
              </select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-3 mr-2">
              <label for="out-customer">Müşteri Adı</label>
              <cool-select v-model="selectedCustomer" id="out-customer" :items="foundCustomers" :loading="customerSearching"
                disable-filtering-by-search  @select="onCustomerSelect"
                @search="onCustomerSearch" item-text="CUSTOMER_TITLE" placeholder="Müşteri...">
                <template slot="no-data">Müşteri bulunamadı</template>
                <div slot="item" class="search-slot-item" slot-scope="{ item }">
                  <p class="text-truncate">{{item.CUSTOMER_TITLE}}</p>
                  <small class="text-primary" >Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
                </div>
              </cool-select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
            <div class="col-md-3">
              <label for="out-contract">Sözleşme Seçimi</label>
              <select class="custom-select" id="out-contract" v-model="selectedContract" @change="onContractSelect($event)">
                <option v-for="(contract, contractIndex) in customerContracts"
                  v-bind:key="'contract-'+ contractIndex"
                  :value="contract.CONTRACT_ID">
                  {{contract.DISPLAY_NAME}}</option>
              </select>
              <div class="invalid-feedback">
                Valid last name is required.
              </div>
            </div>
          </div>
          -->
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <v-wait for="invoice-data-loading">
            <template slot="waiting">
              <div class="vue-wait-class">
                <img src="static/loading.svg" />
                <p>Veriler yükleniyor...</p>
              </div>
            </template>
            <table class="table table-bordered table-striped table-hover">
              <thead class="thead-light">
                <tr>
                  <th style="max-width: 250px;" scope="col">#</th>
                  <th style="width: 10%;" scope="col">FATURA NO</th>
                  <th style="width: 10%;" scope="col">FATURA TARİHİ</th>
                  <th style="width: 10%;" scope="col">BAŞLIK</th>
                  <th style="width: 10%;" scope="col">SÜRE</th>
                  <th style="width: 10%;" scope="col">DURUM</th>
                  <th style="width: 10%;" scope="col">EKLEYEN</th>
                  <th style="width: 10%;" scope="col">DOSYA YÜKLEME TARİHİ</th>
                  <th style="width: 10%;" scope="col">KOMUTLAR</th>
                </tr>
              </thead>
              <tbody class="tbody-margin">
                <template v-for="(invoice, index) in invoices">
                  <tr :key="'trow-first-' + invoice.index">
                    <td class="align-middle text-left">
                      <div class="text-truncate">
                        <p class="margin-negative">{{invoice.CUSTOMER_TITLE}}</p>
                        <small class="text-muted">({{formatDate(invoice.CONTRACT_DATE)}}) {{invoice.CONTRACT_NAME}}</small>
                      </div>
                    </td>
                    <td class="align-middle text-center">{{invoice.INVOICE_ID}}</td>
                    <td class="align-middle text-center">{{formatDate(invoice.INVOICE_DATE)}}</td>
                    <td class="align-middle text-center">{{invoice.INVOICE_TITLE}}</td>
                    <td class="align-middle text-center">{{invoice.INVOICE_LENGTH + ' Ay'}}</td>
                    <td class="align-middle text-center">
                      <div class="text-truncate">
                        <p class="margin-negative">{{invoice.INVOICE_AMOUNT + ' ₺'}}</p>
                        <span class="mt-2 badge" :class="[invoice.INVOICE_STATUS ? 'badge-success': 'badge-danger' ]">{{parseInvoiceStatus(invoice.INVOICE_STATUS)}}</span>
                      </div>
                    </td>
                    <td class="align-middle text-center">{{invoice.PERSONEL_NAME}}</td>
                    <td class="align-middle text-center">{{formatDateTime(invoice.PDF_FILE_ATTACHED_AT)}}</td>
                    <td class="align-middle">
                      <button class="btn btn-sm btn-more-radius btn-success" 
                        @click="downloadInvoice(index)" v-if="invoice.PDF_FILE !== null" >Dosya İndir</button>
                      <button class="btn btn-sm btn-more-radius btn-primary" data-toggle="modal"
                        data-target="#uetdsModalUpdate" v-if="invoice.PDF_FILE === null" @click="selectInvoice(index)">Dosya Yükle</button>
                      <button class="btn btn-sm btn-more-radius btn-danger" data-toggle="modal"
                        data-target="#uetdsDeleteConfirmation" v-if="invoice.PDF_FILE !== null" @click="selectInvoice(index)">Dosya Sil</button>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </v-wait>
        </div>
      </div>
    </div>
    <!--
    <div class="modal fade bd-example-modal-lg" id="uetdsModal" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Luca Kodu Ekleyin/Güncelleyin</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="lcc-inserting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Luca Kodu Kaydediliyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Bayii Adı</label>
                    <select class="custom-select" id="out-retailer" v-model="selectedRetailer">
                      <option value="0" selected>Bayii seçiniz...</option>
                      <option v-for="(retailer, retailerIndex) in retailers"
                        v-bind:key="'retailer-'+ retailerIndex"
                        :value="retailer.RETAILER_ID.toString()">
                        {{retailer.RETAILER_NAME}}</option>
                      <option value="100" selected>Stok Dışı Cihazlar</option>
                      <option value="101" selected>ARIZA</option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-customer">Müşteri Adı</label>
                    <cool-select v-model="selectedCustomer" id="out-customer" :items="foundCustomers" :loading="customerSearching"
                      disable-filtering-by-search  @select="onCustomerSelect"
                      @search="onCustomerSearch" item-text="CUSTOMER_TITLE" placeholder="Müşteri...">
                      <template slot="no-data">Müşteri bulunamadı</template>
                      <div slot="item" class="search-slot-item" slot-scope="{ item }">
                        <p class="text-truncate">{{item.CUSTOMER_TITLE}}</p>
                        <small class="text-primary" >Müşteri Kodu : {{item.CUSTOMER_ID}}</small>
                      </div>
                    </cool-select>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="vehicleName">LUCA KODU</label>
                    <input type="text" class="form-control" v-model="newLCC.lucaCode" id="vehicleName">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="addLCC()" class="btn btn-success">Luca Kodu Ekle/Güncelle</button>
          </div>
        </div>
      </div>
    </div>
    -->
    <div class="modal fade bd-example-modal-lg" id="uetdsModalUpdate" tabindex="-1"
      role="dialog" aria-labelledby="uetdsModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsModalLabel">Fatura Dosyası Yükleme</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="invoice-file-uploading">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Dosya Yükleniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Fatura No</label>
                    <input type="text" disabled class="form-control" :value="selectedInvoice.INVOICE_ID" id="out-retailer">
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Fatura Dosyası</label>
                    <input type="file" :name="uploadFieldName" @change="filesChange($event, $event.target.name, $event.target.files);" class="form-control" id="out-retailer">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="uploadInvoiceFile()" class="btn btn-success">Fatura Dosyası Yükle</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade bd-example-modal-lg" id="uetdsDeleteConfirmation" tabindex="-1"
      role="dialog" aria-labelledby="uetdsDeleteConfirmationLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="uetdsDeleteConfirmationLabel">Fatura Dosyasını Sil</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <v-wait for="invoice-file-deleting">
              <template slot="waiting">
                <div class="vue-wait-class">
                  <img src="static/loading.svg" />
                  <p>Fatuda Dosyası Siliniyor...</p>
                </div>
              </template>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12 mb-3">
                    <label for="out-retailer">Fatura No</label>
                    <input type="text" disabled class="form-control" :value="selectedInvoice.ID" id="out-retailer">
                  </div>
                </div>
              </div>
            </v-wait>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Kapat</button>
            <button type="button" @click="deleteInvoiceFile()" class="btn btn-danger">Fatura Dosyasını Sil</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { CoolSelect } from 'vue-cool-select'
import { isInvoiceFileValid, checkInvoiceFile } from '@/utils/invoiceFileNameChecker'

export default {
  name: 'FaturaYuklemeleriPage2',
  components: {
    Datepicker,
    CoolSelect
  },
  data () {
    return {
      messageText: '',
      retailers:[],
      selectedYear: 2026,
      selectedInvoiceId: 0,
      selectedInvoice: {},
      selectedFile: null,
      uploadFileModel: {
        customerId: 0,
        invoiceId: 0,
        contractId: 0,
        fileName: null,
      },
      invoices: [],
      toastOptions: {
        theme: "bubble",
        position: "top-center",
        duration : 4000
      },
    }
  },
  computed: {
    getPersonelId : function() { return this.$store.getters.getPersonelId },
    getSessionId : function() { return this.$store.getters.getSessionId },
  },
  methods: {
    formatDateTime(date) {
      if(date == null || date == '' || date == undefined) return '-'
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
    formatDate(date) {
      if(date == null || date == '' || date == undefined) return '-'
      return moment(date).format('DD.MM.YYYY');
    },
    parseInvoiceStatus(status) {
      if(status == 0) return "ÖDENMEDİ"
      return "ÖDENDİ"
    },
    filesChange(event, fieldName, fileList) {
      const file = event.target.files[0];
      if (!file) return;

      const result = checkInvoiceFile(file.name, this.selectedInvoice.INVOICE_ID);
      if (!result.ok) {
        alert('Fatura dosyasını kontrol ediniz. Hata: ' + result.reason);
        event.target.value = '';     // secimi temizle
        this.selectedFile = null;
        return;
      }

      this.fileError = '';
      this.selectedFile = file;
    },
    deleteInvoiceFile() {
      axios
      .delete('/api/invoices/' + this.selectedInvoiceId + '/delete-file')
      .then(response => {
        this.selectedInvoiceId = 0;
        this.selectedInvoice = {};

        this.getInvoices();
        $('#uetdsDeleteConfirmation').modal('hide')
      })
    },
    downloadInvoice(index) {
      this.selectedInvoice = this.invoices[index]

        axios
        .get('/api/invoices/' + this.selectedInvoice.ID + '/download-url')
        .then(response => {
          let presignedUrl = response.data.PresignedUrl
          window.open(presignedUrl, '_blank')
        })
        .catch(error => {
          console.log(error)
        })

    },
    selectInvoice(index) {
      this.selectedInvoice = this.invoices[index]
      this.selectedInvoiceId = this.selectedInvoice.ID
    },
    async uploadInvoiceFile() {
      if(this.selectedFile == null) {
        alert('Fatura dosyası seçmediniz.')
      }

      let uploadFileRequest = {
        customerId: this.selectedInvoice.CUSTOMER_ID,
        invoiceId: this.selectedInvoice.ID,
        contractId: this.selectedInvoice.CONTRACT_ID,
        fileName: this.selectedFile.name
      }

      this.$wait.start('invoice-file-uploading');

      axios
      .post('/api/invoices/upload-invoice-file', uploadFileRequest)
      .then(response => {

        console.log(response.data)

        let presignedUrl = response.data.PresignedUrl
        let pdfFile = response.data.PdfFile
        
        fetch(presignedUrl, {
          method: "PUT",
          headers: {
            "Content-Type": "application/pdf",
          },
          body: this.selectedFile,
        })
        .then(response => {

          axios
          .post(
            '/api/invoices/' + this.selectedInvoice.ID + '/mark-file-uploaded', 
            {
              pdfFile: pdfFile
            }
          )
          .then(response => {
            this.$wait.end('invoice-file-uploading');
            this.getInvoices();
            $('#uetdsModalUpdate').modal('hide')
          })
          .finally(() => {
            this.selectedInvoiceId = 0;
            this.selectedInvoice = {};
            this.selectedFile = null
          })
        })

      })
      .catch(error => {
        console.log(error)
      })
    },
    onYearChange() {
      this.getInvoices()
    },
    getInvoices() {
      this.$wait.start('invoice-data-loading');

      axios
      .get('/api/invoices/without-file?year=' + parseInt(this.selectedYear))
      .then(response => {
        this.invoices = response.data
        this.$wait.end('invoice-data-loading')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('invoice-data-loading')
      })
    },
    addInvoice() {
      this.$wait.start('invoice-inserting');

      console.log('invoice to be added/updated: ', this.newInvoice)
      
      axios
      .post('/api/invoices', this.newInvoice)
      .then(response => {
        this.$wait.end('invoice-inserting')
        this.getInvoices()

        this.selectedInvoice = null;
        this.selectedInvoiceId = 0;

        $('#uetdsModal').modal('hide')
        $('#uetdsModalUpdate').modal('hide')
      })
      .catch(error => {
        console.log(error)
        this.$wait.end('lcc-inserting')
      })
    },
  },
  mounted() {
    this.getInvoices()
  }
}
</script>

<style scoped>

  div.icon-global {
    position: absolute;
    z-index: 3;
    margin-left: -36px;
    margin-top: 24px;
    width: 30px;
    height: 30px;
    padding: 4px 4px 5px 4px;
    border-radius: 15px;
  }

  div.icon-global.bg-danger {
    margin-top: -6px !important;
  }

  div.icon-global i {
    color: #FFF;
  }

  .margin-negative {
    margin-bottom: -4px !important;
  }

  input.btn-more-radius {
    text-indent: 10px;
  }

  .table-row {
    display: block;
    width: 100%;
  }
  
  table { caption-side: top !important; }
  table, .dropdown-item {
    font-size: .875rem;
  }

  td .btn {
    font-size: 0.875rem;
  }

  td a.btn {
    font-size: .875rem;
  }

  .btn i {
    color: #FFF;
  }

  .btn:hover i {
    color: #FFF !important;
  }

  tr.collapsed-row {
    background: #F0F0F0;
    /*-webkit-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    -moz-box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);
    box-shadow: inset 0px 5px 30px -15px rgba(102,102,102,1);*/
  }

  span.badge {
    font-size: 100%;
    font-weight: 400;
  }

  .vue-wait-class {
    display: block;
    width: 300px;
    text-align: center;
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
  }

  .vue-wait-class img {
    width: 160px;
    height: 160px;
    margin: 10px auto 0 auto;
    clear: both;
  }

  .vue-wait-class p {
    width: 100%;
    text-align: center;
    font-size: 20px;
  }

  .no-padding {
    padding: 0;
    margin: 0;
  }

  .no-padding .row {
    margin: 0;
  }

  .no-padding .row .col-md-12, .no-padding .row .col-md-9, .no-padding .row .col-md-3 {
    margin: 0 !important;
    padding: 0 !important;
  }

  .caption {
    font-size: 15px;
    font-weight: 700;
    color: #e9ecef;
    background-color: #010929;
    vertical-align: center;
    padding: 11px 15px 12px 15px;
  }
  
  .conversation-view {
    display: block;
    position: absolute;
    z-index: 2;
    width: 350px;
    height: 70%;
    left: 3%;
    bottom: 4.5%;
    border: 1px solid #dee2e6;

    -webkit-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    -moz-box-shadow: 0px 10px 30px -4px rgba(200,200,200,1);
    box-shadow: 0px 10px 30px -4px rgba(200,200,200,1); 
  }

  .bubble span {
    display: inline-block;
    min-width: 120px !important;
    width: auto;
    max-width: 70%;
    padding: 6px 20px;
    color: #fff;
    background-color: #007bff;
    border-radius: 30px;
  }

  .bubble small {
    display: block;
    width: 100%;
    margin-left: 8px;
    font-size: 75%;
  }

  .bubble.own span {
    background-color: #e83e8c;
  }

  .bubble.own small {
    margin-right: 8px;
  }

  .modal-body-fixed {
    height: 300px;
    max-height: 300px !important;
    overflow: auto;
  }

  .overflow-y {
    min-height: 100%;
    overflow: auto !important;
  }

  .text-truncated {
    display: block !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/FaturaYuklemeleriPage2.vue